import { contentAi } from '@mi-front/api-clients';
import { Form, FormLabel, TextField } from '@mi-front/ui';
import CheckIcon from '@mui/icons-material/Check';
import { Box } from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { useWizard } from 'react-use-wizard';
import { useIntl } from 'react-intl';
import { HtmlEditor } from '../../../../../../components/form/HtmlEditor';
import { useContent } from '../../../../hooks/useContent';
import { ContentContainer, PrimaryButton } from '../../components';

export function ContentWizard_UserArticleStep({ content }: { content: contentAi.ContentDto }) {
  const queryClient = useQueryClient();
  const query = useContent(content.id);
  const mutation = contentAi.useContentUpdateUserArticle();
  const { nextStep } = useWizard();
  const { $t } = useIntl();

  if (!query.data) {
    return null;
  }

  return (
    <ContentContainer>
      <Form
        key={JSON.stringify(query.data.userArticle.data)}
        initialValues={query.data.userArticle.data}
        onSubmit={async (data: any) => {
          mutation.mutate(
            {
              id: content.id,
              data: {
                title: data.title,
                body: data.body,
              },
            },
            {
              onSuccess: async () => {
                await queryClient.invalidateQueries({
                  queryKey: query.queryKey,
                });
                nextStep();
              },
            },
          );
        }}
        actions={(fp) => (
          <Box display="flex" justifyContent="flex-start" mt={3}>
            <PrimaryButton
              onClick={async () => fp.submitForm()}
              loading={mutation.isPending}
              startIcon={<CheckIcon />}
              sx={{ padding: '8px 24px', height: '44px' }}
            >
              {$t({
                id: 'contentAi.saveAndContinue',
                defaultMessage: 'Guardar y continuar',
              })}
            </PrimaryButton>
          </Box>
        )}
      >
        {(fp) => (
          <Box display="flex" flexDirection="column" gap={2}>
            <TextField
              name="title"
              label={$t({
                id: 'common.text.title',
                defaultMessage: 'Título',
              })}
            />
            <FormLabel>
              {$t({
                id: 'common.text.content',
                defaultMessage: 'Contenido',
              })}
            </FormLabel>
            <HtmlEditor
              value={query.data?.userArticle.data?.body}
              onChange={(value) => fp.setFieldValue('body', value)}
            />
          </Box>
        )}
      </Form>
    </ContentContainer>
  );
}
